import { compareValues } from "@sscs/utils";
import { AUTH_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import {
  GeneratePersonalAccessTokenRequest,
  GeneratePersonalAccessTokenResponse,
  GetPersonalAccessTokensRequest,
  GetPersonalAccessTokensResponse,
  RevokeAllPersonalAccessTokensRequest,
  RevokeAllPersonalAccessTokensResponse,
  RevokePersonalAccessTokensRequest,
  RevokePersonalAccessTokensResponse,
} from "../types";

export const addTagTypes = [
  "Authentication",
  "SSO",
  "PersonalAccessTokens",
] as const;

export const personalAccessTokensApi = baseApi
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      generatePersonalAccessToken: build.mutation<
        GeneratePersonalAccessTokenResponse,
        GeneratePersonalAccessTokenRequest
      >({
        query: (queryArg) => ({
          url: `${AUTH_ENDPOINT}/personal-access-tokens/${queryArg.userId}`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PersonalAccessTokens"],
      }),
      getPersonalAccessTokens: build.query<
        GetPersonalAccessTokensResponse,
        GetPersonalAccessTokensRequest
      >({
        query: (queryArg) => ({
          url: `${AUTH_ENDPOINT}/personal-access-tokens/${queryArg.userId}`,
        }),
        providesTags: ["PersonalAccessTokens"],
        transformResponse: (
          data: GetPersonalAccessTokensResponse,
        ): GetPersonalAccessTokensResponse => {
          return {
            match_count: data.match_count,
            tokens: data.tokens.sort((first, second) =>
              compareValues(first.created, second.created, true),
            ),
          };
        },
      }),
      revokePersonalAccessToken: build.mutation<
        RevokePersonalAccessTokensResponse,
        RevokePersonalAccessTokensRequest
      >({
        query: (queryArg) => ({
          url: `${AUTH_ENDPOINT}/personal-access-tokens/${queryArg.userId}/revoke/${queryArg.tokenDigest}`,
          method: "DELETE",
        }),
        invalidatesTags: ["PersonalAccessTokens"],
      }),
      revokeAllPersonalAccessTokens: build.mutation<
        RevokeAllPersonalAccessTokensResponse,
        RevokeAllPersonalAccessTokensRequest
      >({
        query: (queryArg) => ({
          url: `${AUTH_ENDPOINT}/personal-access-tokens/${queryArg.userId}/revoke-all`,
          method: "DELETE",
        }),
        invalidatesTags: ["PersonalAccessTokens"],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGeneratePersonalAccessTokenMutation,
  useGetPersonalAccessTokensQuery,
  useRevokePersonalAccessTokenMutation,
  useRevokeAllPersonalAccessTokensMutation,
} = personalAccessTokensApi;
